import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, toDisplayString, normalizeClass, Fragment, renderList, createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "size-chart"
};
const _hoisted_2 = {
  class: "size-chart__table-title"
};
const _hoisted_3 = {
  class: "size-chart__table-wrapper"
};
const _hoisted_4 = ["aria-describedby"];
const _hoisted_5 = {
  scope: "row"
};
const _hoisted_6 = {
  key: 0,
  id: "size-notes",
  class: "size-chart__notes"
};
const _hoisted_7 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "GenericSizeChart",
  props: {
    tableData: {
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const ariaDescribedby = computed(() => {
      var _a;
      return ((_a = props.tableData) == null ? void 0 : _a.notes) ? "size-notes" : null;
    });
    return (_ctx, _cache) => {
      return _ctx.tableData ? (openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("span", _hoisted_2, toDisplayString(_ctx.tableData.title), 1), createElementVNode("div", _hoisted_3, [createElementVNode("table", {
        tabindex: "0",
        "aria-label": "size-chart",
        "aria-describedby": ariaDescribedby.value,
        class: normalizeClass({
          "size-chart__table--width-adjustment": _ctx.tableData.sizes.length > 6
        })
      }, [createElementVNode("thead", null, [createElementVNode("tr", null, [_cache[0] || (_cache[0] = createElementVNode("th", {
        "aria-hidden": "true"
      }, null, -1)), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tableData.sizes, (size) => {
        return openBlock(), createElementBlock("th", {
          key: size.key,
          scope: "col"
        }, toDisplayString(size.label), 1);
      }), 128))])]), createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tableData.rows, (row) => {
        return openBlock(), createElementBlock("tr", {
          key: row.attribute.key
        }, [createElementVNode("th", _hoisted_5, toDisplayString(row.attribute.label), 1), (openBlock(true), createElementBlock(Fragment, null, renderList(row.values, (value) => {
          return openBlock(), createElementBlock("td", {
            key: value.key
          }, toDisplayString(value.label), 1);
        }), 128))]);
      }), 128))])], 10, _hoisted_4)]), _ctx.tableData.notes ? (openBlock(), createElementBlock("div", _hoisted_6, [_cache[1] || (_cache[1] = createElementVNode("h2", {
        class: "size-chart__notes__heading"
      }, " Sizing Notes ", -1)), createElementVNode("p", {
        class: "size-chart__notes__details",
        innerHTML: _ctx.tableData.notes
      }, null, 8, _hoisted_7)])) : createCommentVNode("", true)])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=GenericSizeChart2.mjs.map
